@if (isEditMerchantDiscount() === true) {
  <div class="update-discount-header">
    <h2 matDialogTitle class="mat-h2">Edit Discount</h2>
    @if (data.merchantDiscount && data.merchantDiscount.discount_source !== 'shopify') {
      <button mat-raised-button color="warn" (click)="onDeleteButtonClick(); triggerAnalytics('Discounts_DeleteDiscount_button', 'Discounts')" [disabled]="disableDeleteButton()">Delete</button>
    }
  </div>
}
@else {
  <h2 matDialogTitle class="mat-h2">Create Discount</h2>
}

<mat-dialog-content class="mat-body-2">
  <mat-divider></mat-divider>
  @if (data.merchantDiscount && data.merchantDiscount.discount_source === 'shopify') {
    <div style="display: flex;">
      <form [formGroup]="shopifyFormFormGroup">
        <div class="form-field-row">
          <mat-form-field floatLabel="always" class="shopify-form-field">
            <mat-label>Discount Title</mat-label>
            <input matInput placeholder="Name of discount or promotion" formControlName="titleInput" required cdkFocusInitial>
            <mat-error>{{ discountDetailsFormControls.titleInput.errors | validationMessage }}</mat-error>
            <mat-hint>Cannot be edited in AvantLink while Shopify Sync is on</mat-hint>
          </mat-form-field>
        </div>
        <div class="form-field-row" disabled>
          <mat-form-field floatLabel="always" class="shopify-form-field">
            <mat-label>Coupon Code</mat-label>
            <input matInput formControlName="couponCodeInput" (click)="triggerAnalytics('Discounts_CreateDiscount_DiscountRules_couponcode', 'Discounts')">
            <mat-hint>Cannot be edited in AvantLink while Shopify Sync is on</mat-hint>
            <mat-error>{{ discountRulesFormControls.couponCodeInput.errors | validationMessage }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-field-row">
          <mat-form-field class="shopify-form-field">
            <mat-label>Coupon Code Rule Type</mat-label>
            <mat-select formControlName="ruleTypeSelect"
                        (focus)="triggerAnalytics('Discounts_CreateDiscount_DiscountRules_couponcoderuletype', 'Discounts')">
              @for (discountRuleTypeOption of ['none', 'exclusive', 'restricted', 'qualified']; track discountRuleTypeOption) {
                <mat-option [value]="discountRuleTypeOption">{{ discountRuleTypeOption | titlecase }}</mat-option>
              }
            </mat-select>
            @if (shopifyFormControls.ruleTypeSelect.disabled) {
              <mat-hint>Rules can only be applied to discounts with a coupon code</mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="loading-spinner-container" style="margin: 0;">
          @if (!isMerchantDefaultUrlLoaded()) {
            <div class="loading-spinner">
              <mat-spinner color="accent" [diameter]="20"></mat-spinner>
            </div>
          }
          @if (isMerchantDefaultUrlLoaded()) {
            <div class="form-field-row">
              <mat-form-field class="shopify-form-field">
                <mat-label>Destination URL</mat-label>
                <input formControlName="destinationUrlInput" matInput placeholder="This is the ad destination"
                       required>
                <mat-error>{{ discountDetailsFormControls.destinationUrlInput.errors | validationMessage }}</mat-error>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="form-field-row">
          <mat-form-field floatLabel="always" class="shopify-form-field">
            <mat-label>Designated Affiliate(s)</mat-label>
            <input type="text"
                   [placeholder]="(shopifyFormControls.ruleTypeSelect.valueChanges | async) === 'exclusive' ? 'Affiliate Name, URL, Classic ID' : 'Affiliate Name, URL, Classic ID, Tag Group'"
                   aria-label="Affiliate"
                   matInput
                   formControlName="affiliateAutoComplete"
                   [matAutocomplete]="affiliateAuto"
                   #affiliateInput>
            <mat-autocomplete #affiliateAuto="matAutocomplete" [displayWith]="affiliateFilterDisplayWith"
                              hideSingleSelectionIndicator="true"
                              (optionSelected)="onSelectedAffiliateFilterAutoComplete($event, affiliateInput)"
                              (opened)="onOpenAutoSelect(shopifyFormControls.affiliateAutoComplete)"
                              (closed)="onCloseAffiliateFilterAutoComplete()">
              @if (shopifyFormControls.ruleTypeSelect.value === 'restricted' || shopifyFormControls.ruleTypeSelect.value === 'none') {
                <mat-option [value]="allAffiliatesOption"
                            class="autocomplete-option">{{ allAffiliatesOption.affiliate_name }}
                </mat-option>
              }
              @if (shopifyFormControls.ruleTypeSelect.value === 'none') {
                <mat-option [value]="noAffiliateOption" class="autocomplete-option">{{ noAffiliateOption.affiliate_name }}</mat-option>
              }
              @for (affiliateOption of affiliateFilteredOptionsLimited$ | async; track affiliateOption.affiliate_website_id) {
                <mat-option class="autocomplete-option" [value]="affiliateOption">
                  <div class="mat-subtitle-2">{{ affiliateOption.affiliate_name }}</div>
                  <div class="mat-body-2">{{ affiliateOption.affiliate_website_url_protocol_stripped }}</div>
                  <span class="circle circle-green">&nbsp;</span>
                  <span><mat-icon [svgIcon]="affiliateOption.affiliate_network"></mat-icon></span>
                  <span class="classic-id mat-caption">{{ affiliateOption.classic_affiliate_id }}</span>
                </mat-option>
              }
              @if (this.shopifyFormControls.ruleTypeSelect.value === 'qualified' || this.shopifyFormControls.ruleTypeSelect.value === 'none') {
                <mat-divider></mat-divider>
                <mat-optgroup [label]="'Tag Groups'">
                  @for (tagOption of userTagFilteredOptionsLimited$ | async; track tagOption.tag_id) {
                    <mat-option class="autocomplete-tag-option" [value]="tagOption">
                          <span><mat-icon aria-hidden="false" aria-label="Tag Group icon"
                                          color="accent">groups</mat-icon></span><span
                      class="mat-body-2">{{ tagOption.tag_name | titlecase }}</span>
                    </mat-option>
                  }
                </mat-optgroup>
              }
              @if ((affiliateFilteredOptions$ | async)?.length > affiliateOptionLimit || (userTagFilteredOptions$ | async)?.length > tagGroupOptionLimit) {
                <mat-option [disabled]="true" class="autocomplete-option">
                  <p class="mat-subtitle-2">Filter to see more results.</p>
                </mat-option>
              }
            </mat-autocomplete>
            <mat-hint>Designated affiliates that can use the discount</mat-hint>
          </mat-form-field>
        </div>
        <div class="form-field-row">
          <button mat-button class="white" [mat-dialog-close]="false">Cancel</button>
          <button mat-raised-button color="primary"
                  [disabled]="!shopifyFormFormGroup.valid || disableSubmitButton()"
                  (click)="onSaveButtonClick()">Save
          </button>
        </div>
      </form>
      @if (!isMobile() && shopifyFormControls.ruleTypeSelect.value !== 'none') {
        <div class="card-like discount-type-explanation shopify-discount">
          @if (shopifyFormControls.ruleTypeSelect.value === 'exclusive') {
            <div>
              <mat-icon class="blue" style="margin-right: 8px;">info</mat-icon>
              <span class="explanation-header">Exclusive Coupon Code Rule</span>
            </div>
            <div class="explanation-body">
              Commission an affiliate on all orders that use a specific coupon code. Intended for influencers,
              podcasts, and affiliates that are able to drive traffic to your site but do not have a way to use a
              tracking link.
            </div>
          }
          @if (shopifyFormControls.ruleTypeSelect.value === 'restricted') {
            <div>
              <mat-icon class="blue" style="margin-right: 8px;">info</mat-icon>
              <span class="explanation-header">Restricted Coupon Code Rule</span>
            </div>
            <div class="explanation-body">
              Prevent affiliates from earning commission when a specific coupon code is used. Order will track, but
              commission will not be awarded.
            </div>
          }
          @if (shopifyFormControls.ruleTypeSelect.value === 'qualified') {
            <div>
              <mat-icon class="blue" style="margin-right: 8px;">info</mat-icon>
              <span class="explanation-header">Qualified Coupon Code Rule</span>
            </div>
            <div class="explanation-body">
              Commission specific affiliate(s) when both an affiliate click and a coupon code is used on an order.
              Commission will not be awarded if the coupon code is used by affiliates that are not authorized to use
              it.
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <mat-stepper #stepper labelPosition="bottom" class="blue" orientation="vertical">
      <mat-step color="accent" [stepControl]="discountDetailsFormGroup" errorMessage="Input is invalid">
        <ng-template matStepLabel>Discount Title and Details</ng-template>
        <form [formGroup]="discountDetailsFormGroup">
          <div class="form-field-row">
            <mat-form-field floatLabel="always">
              <mat-label>Discount Title</mat-label>
              <input matInput placeholder="Name of discount or promotion" formControlName="titleInput" required
                     cdkFocusInitial>
              <mat-error>{{ discountDetailsFormControls.titleInput.errors | validationMessage }}</mat-error>
              <mat-hint>Used by affiliates for promotions and content</mat-hint>
            </mat-form-field>
          </div>
          <div class="form-field-row">
            <mat-form-field floatLabel="always">
              <mat-label>Discount Details</mat-label>
              <input matInput placeholder="Description of discount and stipulations" formControlName="detailsInput"
                     required>
              <mat-error>{{ discountDetailsFormControls.detailsInput.errors | validationMessage }}</mat-error>
              <mat-hint>Include qualifications for discount use. <a
                href="{{environment.supportUrl}}/hc/en-us/articles/29866860679323-Discounts-Merchant-User-Guide-Creating-Discounts-Promotions-and-Coupon-Codes"
                target="_blank">Learn More</a></mat-hint>
            </mat-form-field>
          </div>
          <div class="loading-spinner-container">
            @if (!isMerchantDefaultUrlLoaded()) {
              <div class="loading-spinner">
                <mat-spinner color="accent" [diameter]="20"></mat-spinner>
              </div>
            }
            @if (isMerchantDefaultUrlLoaded()) {
              <div class="form-field-row">
                <mat-form-field>
                  <mat-label>Destination URL</mat-label>
                  <input formControlName="destinationUrlInput" matInput placeholder="This is the ad destination"
                         required>
                  <mat-error>{{ discountDetailsFormControls.destinationUrlInput.errors | validationMessage }}</mat-error>
                </mat-form-field>
              </div>
            }
          </div>
          <div class="form-field-row">
            <button mat-raised-button color="primary" matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="discountScheduleFormGroup" errorMessage="Input is invalid">
        <ng-template matStepLabel>Discount Schedule</ng-template>
        <form [formGroup]="discountScheduleFormGroup">
          <div class="form-field-row">
            <mat-form-field class="discount-schedule" style="margin-right: 8px;" floatLabel="always">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker" formControlName="startDatePicker"
                     [matDatepickerFilter]="startDateValidation" placeholder="Starts now">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
              <mat-hint>Leave blank to start immediately</mat-hint>
              <mat-error>
                @if (discountScheduleFormControls.startDatePicker.hasError('matDatepickerParse')) {
                  Please enter a valid date
                }
                @if (!discountScheduleFormControls.startDatePicker.hasError('matDatepickerParse')) {
                  {{ discountScheduleFormControls.startDatePicker.errors | validationMessage }}
                }
              </mat-error>
            </mat-form-field>
            <mat-form-field class="discount-schedule" floatLabel="always">
              <mat-label>Start Time</mat-label>
              <input matInput type="time"
                     [type]="discountScheduleFormControls.startTimeInput.disabled ? 'text' : 'time'"
                     formControlName="startTimeInput" placeholder="Starts now">
              <mat-hint>Mountain Time</mat-hint>
              <mat-error>{{ discountScheduleFormControls.startTimeInput.errors | validationMessage }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-row">
            <mat-form-field floatLabel="always" class="discount-schedule" style="margin-right: 8px;">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endDatePicker" formControlName="endDatePicker" placeholder="No end date"
                     [min]="discountScheduleFormControls.startDatePicker.value">
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
              <mat-hint>Leave blank for no end date</mat-hint>
              <mat-error>
                @if (discountScheduleFormControls.endDatePicker.hasError('matDatepickerParse')) {
                  Please enter a valid date
                }
                @if (!discountScheduleFormControls.endDatePicker.hasError('matDatepickerParse')) {
                  {{ discountScheduleFormControls.endDatePicker.errors | validationMessage }}
                }
              </mat-error>
            </mat-form-field>
            <mat-form-field floatLabel="always" class="discount-schedule">
              <mat-label>End Time</mat-label>
              <input matInput [type]="discountScheduleFormControls.endTimeInput.disabled ? 'text' : 'time'"
                     formControlName="endTimeInput" placeholder="N/A">
              <mat-hint>Mountain Time</mat-hint>
              <mat-error>{{ discountScheduleFormControls.endTimeInput.errors | validationMessage }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-row">
            <button mat-button class="back-button" matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step color="accent" [stepControl]="discountRulesFormGroup" errorMessage="Input is invalid">
        <ng-template matStepLabel>Discount Rules</ng-template>
        <div style="display: flex;">
          <form [formGroup]="discountRulesFormGroup">
            <div class="form-field-row">
              <mat-form-field floatLabel="always" class="discount-rules">
                <mat-label>Coupon Code</mat-label>
                <input matInput placeholder="Enter Coupon Code (optional)" formControlName="couponCodeInput"
                       (click)="triggerAnalytics('Discounts_CreateDiscount_DiscountRules_couponcode', 'Discounts')">
                @if (discountRulesFormControls.ruleTypeSelect.value !== 'none') {
                  <mat-hint>An asterisk can be used as a <a
                    href="{{environment.supportUrl}}/hc/en-us/articles/24509523367707-How-Merchants-can-Apply-a-Commission-Rule-to-Multiple-Coupon-Codes-using-Wildcard-Character"
                    target="_blank">wildcard character</a></mat-hint>
                }
                <mat-error>{{ discountRulesFormControls.couponCodeInput.errors | validationMessage }}</mat-error>
              </mat-form-field>
            </div>
            <div style="margin-bottom: 36px;">
              <mat-form-field class="discount-rules">
                <mat-label>Coupon Code Rule Type</mat-label>
                <mat-select formControlName="ruleTypeSelect"
                            (focus)="triggerAnalytics('Discounts_CreateDiscount_DiscountRules_couponcoderuletype', 'Discounts')">
                  @for (discountRuleTypeOption of ['none', 'exclusive', 'restricted', 'qualified']; track discountRuleTypeOption) {
                    <mat-option [value]="discountRuleTypeOption">{{ discountRuleTypeOption | titlecase }}</mat-option>
                  }
                </mat-select>
                <mat-hint>Must enter coupon code to apply rule</mat-hint>
              </mat-form-field>
            </div>
            <div class="form-field-row">
              <mat-form-field floatLabel="always" class="discount-rules">
                <mat-label>Designated Affiliate(s)</mat-label>
                <input type="text"
                       [placeholder]="(discountRulesFormControls.ruleTypeSelect.valueChanges | async) === 'exclusive' ? 'Affiliate Name, URL, Classic ID' : 'Affiliate Name, URL, Classic ID, Tag Group'"
                       aria-label="Affiliate"
                       matInput
                       formControlName="affiliateAutoComplete"
                       [matAutocomplete]="affiliateAuto"
                       #affiliateInput>
                <mat-autocomplete #affiliateAuto="matAutocomplete" [displayWith]="affiliateFilterDisplayWith"
                                  hideSingleSelectionIndicator="true"
                                  (optionSelected)="onSelectedAffiliateFilterAutoComplete($event, affiliateInput)"
                                  (opened)="onOpenAutoSelect(discountRulesFormControls.affiliateAutoComplete)"
                                  (closed)="onCloseAffiliateFilterAutoComplete()">
                  @if (discountRulesFormControls.ruleTypeSelect.value === 'restricted' || discountRulesFormControls.ruleTypeSelect.value === 'none') {
                    <mat-option [value]="allAffiliatesOption" class="autocomplete-option">{{ allAffiliatesOption.affiliate_name }}</mat-option>
                  }
                  @if (discountRulesFormControls.ruleTypeSelect.value === 'none') {
                    <mat-option [value]="noAffiliateOption" class="autocomplete-option">{{ noAffiliateOption.affiliate_name }}</mat-option>
                  }
                  @for (affiliateOption of affiliateFilteredOptionsLimited$ | async; track affiliateOption.affiliate_website_id) {
                    <mat-option class="autocomplete-option" [value]="affiliateOption">
                      <div class="mat-subtitle-2">{{ affiliateOption.affiliate_name }}</div>
                      <div class="mat-body-2">{{ affiliateOption.affiliate_website_url_protocol_stripped }}</div>
                      <span class="circle circle-green">&nbsp;</span>
                      <span><mat-icon [svgIcon]="affiliateOption.affiliate_network"></mat-icon></span>
                      <span class="classic-id mat-caption">{{ affiliateOption.classic_affiliate_id }}</span>
                    </mat-option>
                  }
                  @if (this.discountRulesFormControls.ruleTypeSelect.value === 'qualified' || this.discountRulesFormControls.ruleTypeSelect.value === 'none') {
                    <mat-divider></mat-divider>
                    <mat-optgroup [label]="'Tag Groups'">
                      @for (tagOption of userTagFilteredOptionsLimited$ | async; track tagOption.tag_id) {
                        <mat-option class="autocomplete-tag-option" [value]="tagOption">
                          <span><mat-icon aria-hidden="false" aria-label="Tag Group icon"
                                          color="accent">groups</mat-icon></span><span
                          class="mat-body-2">{{ tagOption.tag_name | titlecase }}</span>
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                  @if ((affiliateFilteredOptions$ | async)?.length > affiliateOptionLimit || (userTagFilteredOptions$ | async)?.length > tagGroupOptionLimit) {
                    <mat-option [disabled]="true" class="autocomplete-option">
                      <p class="mat-subtitle-2">Filter to see more results.</p>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-hint>Designated affiliates that can use the discount</mat-hint>
              </mat-form-field>
            </div>
            <div class="form-field-row">
              <button mat-button class="back-button" matStepperPrevious>Back</button>
              <button mat-raised-button color="primary" matStepperNext
                      [disabled]="!discountDetailsFormGroup.valid || !discountScheduleFormGroup.valid || !discountRulesFormGroup.valid || disableSubmitButton()"
                      (click)="onSaveButtonClick()">Save
              </button>
            </div>
          </form>
          @if (!isMobile() && discountRulesFormControls.ruleTypeSelect.value !== 'none') {
            <div class="card-like discount-type-explanation">
              @if (discountRulesFormControls.ruleTypeSelect.value === 'exclusive') {
                <div>
                  <mat-icon class="blue" style="margin-right: 8px;">info</mat-icon>
                  <span class="explanation-header">Exclusive Coupon Code Rule</span>
                </div>
                <div class="explanation-body">
                  Commission an affiliate on all orders that use a specific coupon code. Intended for influencers,
                  podcasts, and affiliates that are able to drive traffic to your site but do not have a way to use a
                  tracking link.
                </div>
              }
              @if (discountRulesFormControls.ruleTypeSelect.value === 'restricted') {
                <div>
                  <mat-icon class="blue" style="margin-right: 8px;">info</mat-icon>
                  <span class="explanation-header">Restricted Coupon Code Rule</span>
                </div>
                <div class="explanation-body">
                  Prevent affiliates from earning commission when a specific coupon code is used. Order will track, but
                  commission will not be awarded.
                </div>
              }
              @if (discountRulesFormControls.ruleTypeSelect.value === 'qualified') {
                <div>
                  <mat-icon class="blue" style="margin-right: 8px;">info</mat-icon>
                  <span class="explanation-header">Qualified Coupon Code Rule</span>
                </div>
                <div class="explanation-body">
                  Commission specific affiliate(s) when both an affiliate click and a coupon code is used on an order.
                  Commission will not be awarded if the coupon code is used by affiliates that are not authorized to use
                  it.
                </div>
              }
            </div>
          }
        </div>
      </mat-step>
    </mat-stepper>
  }
</mat-dialog-content>
